import React, { useState, useEffect } from 'react'
import {
  Table,
  IconButton,
  Icon,
  Row,
  Col,
  SelectPicker,
  ControlLabel,
  Input,
  Modal,
  Button,
  Whisper,
  Tooltip,
} from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import { useForm } from 'react-hook-form'
import { searchAllProjectAcc } from '../../redux/actions/dashboard'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { sessionSetItemStr } from '../../utils/sessionHelpers'
import { budgetFormat } from '../../utils/formatterUtil'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { isEmpty } from 'lodash-es'
import WarningDetailWidgets from './WarningDetailWidgets'

export default function TableIncomeAndExpense({ schema, loading, onSearch = () => {}, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [tableData, setTableData] = useState([])
  const [projectCodeVal, setProjectCodeVal] = useState('')
  const [projectNameVal, setProjectNameVal] = useState('')
  const [contractNumberVal, setContractNumberVal] = useState('')
  const [grantreeVal, setGrantreeVal] = useState('')
  const [responsinatorVal, setResponsinatorVal] = useState('')
  const [codinatorVal, setCodinatorVal] = useState('')
  const [totalSize, setTotalSize] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [isShowModalWarning, setIsShowModalWarning] = useState(false)
  const [warningProjectCode, setWarningProjectCode] = useState()

  const history = useHistory()

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }

  useEffect(() => {
    setTableData(schema.datas.values || [])
    setTotalSize(schema?.datas?.totalSize)
  }, [schema])

  const createRequest = () => {
    const request = {
      projectCode: projectCodeVal,
      projectName: projectNameVal,
      contractNumber: contractNumberVal,
      grantree: grantreeVal,
      codinator: codinatorVal,
      responsinator: responsinatorVal,
    }

    return request
  }

  const handleChangePage = (dataKey) => {
    console.log('handleChangePage ', dataKey)

    setPage(dataKey)

    var request = createRequest()
    onSearch(dataKey, displayLength, request)
  }

  const handleChangeLength = (dataKey) => {
    console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)

    var request = createRequest()

    onSearch(1, dataKey, request)
  }

  const handleSearch = () => {
    var request = createRequest()

    onSearch(1, displayLength, request)
  }

  const handleCancel = () => {
    onSearch(1, displayLength, {})
  }

  const handleShowWarningDetail = (rowData) => {
    console.log('handleShowWarningDetail => ', rowData)
    setWarningProjectCode(rowData.projectCode)
    setIsShowModalWarning(true)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      {schema?.searchForm && (
        <dev>
          <Row>
            {schema.searchForm?.projectCode && (
              <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
                <ControlLabel>{schema.searchForm.projectCode.label}</ControlLabel>
                <Input
                  style={{ marginTop: 5 }}
                  name={schema.searchForm.projectCode.name}
                  value={projectCodeVal}
                  placeholder={'ระบุ' + schema.searchForm.projectCode.label}
                  onChange={(value) => {
                    setProjectCodeVal(value)
                  }}
                />
              </Col>
            )}

            {schema.searchForm?.projectName && (
              <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
                <ControlLabel>{schema.searchForm.projectName.label}</ControlLabel>
                <Input
                  style={{ marginTop: 5 }}
                  name={schema.searchForm.projectName.name}
                  value={projectNameVal}
                  placeholder={'ระบุ' + schema.searchForm.projectName.label}
                  onChange={(value) => {
                    setProjectNameVal(value)
                  }}
                />
              </Col>
            )}

            {schema.searchForm?.contractNumber && (
              <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
                <ControlLabel>{schema.searchForm.contractNumber.label}</ControlLabel>
                <Input
                  style={{ marginTop: 5 }}
                  name={schema.searchForm.contractNumber.name}
                  value={contractNumberVal}
                  placeholder={'ระบุ' + schema.searchForm.contractNumber.label}
                  onChange={(value) => {
                    setContractNumberVal(value)
                  }}
                />
              </Col>
            )}

            {schema.searchForm?.grantree && (
              <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
                <ControlLabel>{schema.searchForm.grantree.label}</ControlLabel>
                <Input
                  style={{ marginTop: 5 }}
                  name={schema.searchForm.grantree.name}
                  value={grantreeVal}
                  placeholder={'ระบุ' + schema.searchForm.grantree.label}
                  onChange={(value) => {
                    setGrantreeVal(value)
                  }}
                />
              </Col>
            )}

            {schema.searchForm?.codinatorVal && (
              <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
                <ControlLabel>{schema.searchForm.codinatorVal.label}</ControlLabel>
                <Input
                  style={{ marginTop: 5 }}
                  name={schema.searchForm.codinatorVal.name}
                  value={codinatorVal}
                  placeholder={'ระบุ' + schema.searchForm.codinatorVal.label}
                  onChange={(value) => {
                    setCodinatorVal(value)
                  }}
                />
              </Col>
            )}

            {schema.searchForm?.responsinator && (
              <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
                <ControlLabel>{schema.searchForm.responsinator.label}</ControlLabel>
                <SelectPicker
                  style={{ marginTop: 5 }}
                  data={schema.searchForm.responsinator.options || []}
                  value={responsinatorVal}
                  searchable={false}
                  block
                  placeholder={`เลือก${schema.searchForm.responsinator.label}`}
                  onChange={(value) => {
                    setResponsinatorVal(value)
                  }}
                />
              </Col>
            )}
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={24} md={24} sm={24} xs={24}>
              <SearchButton
                disabled={false}
                onClick={() => {
                  handleSearch()
                }}
              >
                ค้นหา
              </SearchButton>
              <CancelButton
                disabled={false}
                onClick={() => {
                  setProjectCodeVal('')
                  setProjectNameVal('')
                  setContractNumberVal('')
                  setGrantreeVal('')
                  setResponsinatorVal('')
                  setCodinatorVal('')

                  handleCancel()
                }}
              >
                ยกเลิก
              </CancelButton>
            </Col>
          </Row>
        </dev>
      )}

      <Table wordWrap minHeight={350} autoHeight loading={loading} data={tableData}>
        <Column width={80} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return (page - 1) * displayLength + index + 1
            }}
          </Cell>
        </Column>

        <Column width={130} minWidth={130} align="center">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData) => {
              if (rowData.isDisplayWarning == 'YES') {
                return (
                  <>
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={
                        <Tooltip style={{ backgroundColor: '#272c36 !important' }}>
                          คลิกเพื่อแสดงรายละเอียด
                        </Tooltip>
                      }
                    >
                      <span
                        onClick={() => {
                          handleShowWarningDetail(rowData)
                        }}
                        style={{
                          cursor: 'pointer',
                          paddingLeft: 8,
                          paddingRight: 8,
                          paddingTop: 3,
                          paddingBottom: 3,
                          fontWeight: 'bold',
                          color: 'red',
                        }}
                      >
                        <Icon
                          className="animation"
                          style={{ color: '#F44336' }}
                          icon={'exclamation-triangle'}
                        />
                        {`   คลิก`}
                      </span>
                    </Whisper>
                  </>
                )
              }

              if (rowData.isDisplayWarning == 'NO' && rowData.countStatusStickyNote > 0) {
                return (
                  <>
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={
                        <Tooltip style={{ backgroundColor: '#272c36 !important' }}>
                          คลิกเพื่อแสดงรายละเอียด
                        </Tooltip>
                      }
                    >
                      <span
                        onClick={() => {
                          handleShowWarningDetail(rowData)
                        }}
                        style={{
                          cursor: 'pointer',
                          paddingLeft: 8,
                          paddingRight: 8,
                          paddingTop: 3,
                          paddingBottom: 3,
                          fontWeight: 'bold',
                          color: '#2da888',
                        }}
                      >
                        {`   คลิก`}
                      </span>
                    </Whisper>
                  </>
                )
              }

              return ''
            }}
          </Cell>
        </Column>

        <Column width={150}>
          <HeaderCell>รหัสโครงการ</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>

        <Column width={320} minWidth={320} flexGrow={1}>
          <HeaderCell>ชื่อโครงการ</HeaderCell>
          <Cell dataKey="projectName" />
        </Column>

        <Column width={150}>
          <HeaderCell>เลขที่ข้อตกลง</HeaderCell>
          <Cell dataKey="contractNo" />
        </Column>

        <Column width={120} align="right">
          <HeaderCell>จำนวนงวด</HeaderCell>
          <Cell dataKey="periodNum" />
        </Column>

        <Column width={180} align="right">
          <HeaderCell>งบอนุมัติ(บาท)</HeaderCell>
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.budget) || '0.00'
            }}
          </Cell>
        </Column>

        <Column width={200} align="right">
          <HeaderCell>รับโอนเงินงวด(บาท)</HeaderCell>
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.budgetReceipt) || '0.00'
            }}
          </Cell>
        </Column>
        <Column width={160} align="center">
          <HeaderCell>สถานะโครงการ</HeaderCell>
          <Cell dataKey="projectStatus" />
        </Column>
        <Column width={170} align="center">
          <HeaderCell>สถานะครุภัณฑ์โครงการ</HeaderCell>
          <Cell>
            {(rowData) => {
              var result = ''

              if (!isEmpty(rowData.assetRegister)) {
                result = rowData.assetRegister
              }

              if (!isEmpty(rowData.assetClosure)) {
                result = result ? result + ' , ' + rowData.assetClosure : rowData.assetClosure
              }

              return (
                <div style={styleHeaderCell}>
                  {/* {result} */}
                  {rowData.assetRegister && <p>{rowData.assetRegister} </p>}
                  {rowData.assetClosure && <p>{rowData.assetClosure} </p>}
                </div>
              )
            }}
          </Cell>
        </Column>

        <Column width={100} align="center" fixed="right">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  {/* <IconButton
                    appearance="primary"
                    icon={<Icon icon="save" />}
                    onClick={() => {
                      sessionSetItemStr('projectId', rowData.projectId)
                      sessionSetItemStr('projectCode', rowData.projectCode)
                      sessionSetItemStr('param', '')

                      history.push({
                        pathname: pathname.incomeAndExpense.ProjectBasedItems,
                      })
                    }}
                    size="sm"
                  >
                    บันทึก(รับ/จ่าย)
                  </IconButton> */}

                  <IconButton
                    appearance="primary"
                    icon={<Icon icon="eye" />}
                    onClick={() => {
                      // console.log('แสดง', rowData)
                      sessionSetItemStr('projectId', rowData.projectId)
                      sessionSetItemStr('projectCode', rowData.projectCode)
                      sessionSetItemStr('param', '')

                      history.push({
                        pathname: rowData.pathName || pathname.incomeAndExpense.ProjectBasedItems,
                      })
                    }}
                    size="sm"
                    style={{ marginRight: 10 }}
                  >
                    แสดง
                  </IconButton>
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>

      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page || defaultPage}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />

      <WarningDetailWidgets
        show={isShowModalWarning}
        projectCode={warningProjectCode}
        periodNumber={null}
        onCancle={() => {
          var request = createRequest()
          onSearch(page, displayLength, request, true)
          setIsShowModalWarning(false)
        }}
      />
    </>
  )
}
